export const challengeTitle = {
  ACTIVE: "Active Challenges",
  DRAFT: "Fraft Challenges",
  PENDING: "Challenges With Pending Invitation"
};